import React from 'react';
import Button from 'react-bootstrap/Button';
import "./Services.css";
import { Link } from "react-router-dom";

function Services () {
    return (
        <div id='services' className='services-container'>
            <h1>Services <font color="#66A9AFAD">We Provide</font></h1>
            <h6>we offer a wide range of services to meet all of your cleaning and care needs. Our team of<br /> experienced professionals uses the latest technology and techniques to ensure that your<br /> clothes, fabrics, and home are clean, fresh, and well-maintained.</h6>
            <div className='services-content-container'>
                <div className='services-content-card'>
                    <div className='card-image'>
                        <img src={require( "../../images/services/dry-cleaning.png" )} className="card-image-normal" alt="" />
                        <img src={require( "../../images/services/dry-cleaning-dark.png" )} className="card-image-dark" alt="" />
                    </div>
                    <div className='card-head'>
                        <h6>Dry Cleaning</h6>
                    </div>
                    <div className='card-content'>
                        We use eco-friendly cleaning solutions to remove stains, odors, and dirt from your clothes and fabrics, leaving them fresh and clean.
                    </div>
                    <div className='card-price'>
                        <h6>Starts 29 Rs/Piece</h6>
                    </div>
                    <div className='card-button'>
                        <Link to="/pricing" id='form-button-click' style={{ color: "white", textDecoration: "none" }}><Button onMouseEnter={event => {
                            document.querySelectorAll( ".card-image-normal" )[ 0 ].style.display = "none";
                            document.querySelectorAll( ".card-image-dark" )[ 0 ].style.display = "block";
                        }} onMouseLeave={event => {
                            document.querySelectorAll( ".card-image-dark" )[ 0 ].style.display = "none";
                            document.querySelectorAll( ".card-image-normal" )[ 0 ].style.display = "block";
                        }}>Book Now</Button></Link>
                    </div>
                </div>
                <div className='services-content-card'>
                    <div className='card-image'>
                        <img src={require( "../../images/services/wash-and-fold.png" )} className="card-image-normal" alt="" />
                        <img src={require( "../../images/services/wash-and-fold-dark.png" )} className="card-image-dark" alt="" />
                    </div>
                    <div className='card-head'>
                        <h6>Washing and Fold</h6>
                    </div>
                    <div className='card-content'>
                        We will wash, dry, and fold your clothes with care and precision, so you can enjoy fresh, clean laundry service without the hassle.
                    </div>
                    <div className='card-price'>
                        <h6>59 Rs/Kg</h6>
                    </div>
                    <div className='card-button'>
                        <Link to="/pricing" id='form-button-click' style={{ color: "white", textDecoration: "none" }}><Button onMouseEnter={event => {
                            document.querySelectorAll( ".card-image-normal" )[ 1 ].style.display = "none";
                            document.querySelectorAll( ".card-image-dark" )[ 1 ].style.display = "block";
                        }} onMouseLeave={event => {
                            document.querySelectorAll( ".card-image-dark" )[ 1 ].style.display = "none";
                            document.querySelectorAll( ".card-image-normal" )[ 1 ].style.display = "block";
                        }}>Book Now</Button></Link>
                    </div>
                </div>
                <div className='services-content-card'>
                    <div className='card-image'>
                        <img src={require( "../../images/services/wash-and-iron.png" )} className="card-image-normal" alt="" />
                        <img src={require( "../../images/services/wash-and-iron-dark.png" )} className="card-image-dark" alt="" />
                    </div>
                    <div className='card-head'>
                        <h6>Washing and Ironing</h6>
                    </div>
                    <div className='card-content'>
                        Our skilled cleaners will wash and iron your clothes to perfection, leaving them looking neat and tidy at your home doorstep.
                    </div>
                    <div className='card-price'>
                        <h6>79 Rs/Kg</h6>
                    </div>
                    <div className='card-button'>
                        <Link to="/pricing" id='form-button-click' style={{ color: "white", textDecoration: "none" }}><Button onMouseEnter={event => {
                            document.querySelectorAll( ".card-image-normal" )[ 2 ].style.display = "none";
                            document.querySelectorAll( ".card-image-dark" )[ 2 ].style.display = "block";
                        }} onMouseLeave={event => {
                            document.querySelectorAll( ".card-image-dark" )[ 2 ].style.display = "none";
                            document.querySelectorAll( ".card-image-normal" )[ 2 ].style.display = "block";
                        }}>Book Now</Button></Link>
                    </div>
                </div>
                <div className='services-content-card'>
                    <div className='card-image'>
                        <img src={require( "../../images/services/shoe-cleaning.png" )} className="card-image-normal" alt="" />
                        <img src={require( "../../images/services/shoe-cleaning-dark.png" )} className="card-image-dark" alt="" />
                    </div>
                    <div className='card-head'>
                        <h6>Shoe Cleaning</h6>
                    </div>
                    <div className='card-content'>
                        We use specialized cleaning techniques and products to restore your shoes to their original condition, no matter how dirty or worn they are.
                    </div>
                    <div className='card-price'>
                        <h6>299 Rs/Piece</h6>
                    </div>
                    <div className='card-button'>
                        <Link to="/pricing" id='form-button-click' style={{ color: "white", textDecoration: "none" }}><Button onMouseEnter={event => {
                            document.querySelectorAll( ".card-image-normal" )[ 3 ].style.display = "none";
                            document.querySelectorAll( ".card-image-dark" )[ 3 ].style.display = "block";
                        }} onMouseLeave={event => {
                            document.querySelectorAll( ".card-image-dark" )[ 3 ].style.display = "none";
                            document.querySelectorAll( ".card-image-normal" )[ 3 ].style.display = "block";
                        }}>Book Now</Button></Link>
                    </div>
                </div>
                <div className='services-content-card'>
                    <div className='card-image'>
                        <img src={require( "../../images/services/steam-press.png" )} className="card-image-normal" alt="" />
                        <img src={require( "../../images/services/steam-press-dark.png" )} className="card-image-dark" alt="" />
                    </div>
                    <div className='card-head'>
                        <h6>Steam Press</h6>
                    </div>
                    <div className='card-content'>
                        We use advanced steam pressing technology to remove wrinkles and creases from your clothes, leaving them looking smooth and polished.
                    </div>
                    <div className='card-price'>
                        <h6>10 Rs/Piece</h6>
                    </div>
                    <div className='card-button'>
                        <Link to="/pricing" id='form-button-click' style={{ color: "white", textDecoration: "none" }}><Button onMouseEnter={event => {
                            document.querySelectorAll( ".card-image-normal" )[ 4 ].style.display = "none";
                            document.querySelectorAll( ".card-image-dark" )[ 4 ].style.display = "block";
                        }} onMouseLeave={event => {
                            document.querySelectorAll( ".card-image-dark" )[ 4 ].style.display = "none";
                            document.querySelectorAll( ".card-image-normal" )[ 4 ].style.display = "block";
                        }}>Book Now</Button></Link>
                    </div>
                </div>
                <div className='services-content-card'>
                    <div className='card-image'>
                        <img src={require( "../../images/services/sofa-cleaning.png" )} className="card-image-normal" alt="" />
                        <img src={require( "../../images/services/sofa-cleaning-dark.png" )} className="card-image-dark" alt="" />
                    </div>
                    <div className='card-head'>
                        <h6>Sofa Cleaning</h6>
                    </div>
                    <div className='card-content'>
                        Our expert cleaners will remove dirt, dust, and allergens from your sofa, leaving it looking and smelling like new Sofa.
                    </div>
                    <div className='card-price'>
                        <h6>249 Rs/Seat</h6>
                    </div>
                    <div className='card-button'>
                        <Link to="/pricing" id='form-button-click' style={{ color: "white", textDecoration: "none" }}><Button onMouseEnter={event => {
                            document.querySelectorAll( ".card-image-normal" )[ 5 ].style.display = "none";
                            document.querySelectorAll( ".card-image-dark" )[ 5 ].style.display = "block";
                        }} onMouseLeave={event => {
                            document.querySelectorAll( ".card-image-dark" )[ 5 ].style.display = "none";
                            document.querySelectorAll( ".card-image-normal" )[ 5 ].style.display = "block";
                        }}>Book Now</Button></Link>
                    </div>
                </div>
                <div className='services-content-card'>
                    <div className='card-image'>
                        <img src={require( "../../images/services/house-cleaning.png" )} className="card-image-normal" alt="" />
                        <img src={require( "../../images/services/house-cleaning-dark.png" )} className="card-image-dark" alt="" />
                    </div>
                    <div className='card-head'>
                        <h6>House Cleaning</h6>
                    </div>
                    <div className='card-content'>
                        Our team of professionals will clean every nook and cranny of your home, from bathrooms and kitchens to bedrooms and living spaces.
                    </div>
                    <div className='card-price'>
                        <h6>5 Rs/Sqft</h6>
                    </div>
                    <div className='card-button'>
                        <Link to="/pricing" id='form-button-click' style={{ color: "white", textDecoration: "none" }}><Button onMouseEnter={event => {
                            document.querySelectorAll( ".card-image-normal" )[ 6 ].style.display = "none";
                            document.querySelectorAll( ".card-image-dark" )[ 6 ].style.display = "block";
                        }} onMouseLeave={event => {
                            document.querySelectorAll( ".card-image-dark" )[ 6 ].style.display = "none";
                            document.querySelectorAll( ".card-image-normal" )[ 6 ].style.display = "block";
                        }}>Book Now</Button></Link>
                    </div>
                </div>
                <div className='services-content-card'>
                    <div className='card-image'>
                        <img src={require( "../../images/services/saree-polish.png" )} className="card-image-normal" alt="" />
                        <img src={require( "../../images/services/saree-polish-dark.png" )} className="card-image-dark" alt="" />
                    </div>
                    <div className='card-head'>
                        <h6>Saree Polish</h6>
                    </div>
                    <div className='card-content'>
                        Our team of experts will clean, polish, and press your sarees, leaving them looking vibrant and beautiful while delivering to your home.
                    </div>
                    <div className='card-price'>
                        <h6>89 Rs/Piece</h6>
                    </div>
                    <div className='card-button'>
                        <Link to="/pricing" id='form-button-click' style={{ color: "white", textDecoration: "none" }}><Button onMouseEnter={event => {
                            document.querySelectorAll( ".card-image-normal" )[ 7 ].style.display = "none";
                            document.querySelectorAll( ".card-image-dark" )[ 7 ].style.display = "block";
                        }} onMouseLeave={event => {
                            document.querySelectorAll( ".card-image-dark" )[ 7 ].style.display = "none";
                            document.querySelectorAll( ".card-image-normal" )[ 7 ].style.display = "block";
                        }}>Book Now</Button></Link>
                    </div>
                </div>
            </div>
            <swiper-container autoplay loop={true} autoplay-delay={6000} space-between={40} slides-per-view={1} scrollbar={true} className='services-content-container'>
                <swiper-slide className='services-content-card'>
                    <div className='card-image'>
                        <img src={require( "../../images/services/dry-cleaning.png" )} className="card-image-normal" alt="" />
                        <img src={require( "../../images/services/dry-cleaning-dark.png" )} className="card-image-dark" alt="" />
                    </div>
                    <div className='card-head'>
                        <h6>Dry Cleaning</h6>
                    </div>
                    <div className='card-content'>
                        We use eco-friendly cleaning solutions to remove stains, odors, and dirt from your clothes and fabrics, leaving them fresh and clean.
                    </div>
                    <div className='card-price'>
                        <h6>Starts 29 Rs/Piece</h6>
                    </div>
                    <div className='card-button'>
                        <Link to="/pricing" id='form-button-click' style={{ color: "white", textDecoration: "none" }}><Button onMouseEnter={event => {
                            document.querySelectorAll( ".card-image-normal" )[ 0 ].style.display = "none";
                            document.querySelectorAll( ".card-image-dark" )[ 0 ].style.display = "block";
                        }} onMouseLeave={event => {
                            document.querySelectorAll( ".card-image-dark" )[ 0 ].style.display = "none";
                            document.querySelectorAll( ".card-image-normal" )[ 0 ].style.display = "block";
                        }}>Book Now</Button></Link>
                    </div>
                </swiper-slide>
                <swiper-slide className='services-content-card'>
                    <div className='card-image'>
                        <img src={require( "../../images/services/wash-and-fold.png" )} className="card-image-normal" alt="" />
                        <img src={require( "../../images/services/wash-and-fold-dark.png" )} className="card-image-dark" alt="" />
                    </div>
                    <div className='card-head'>
                        <h6>Washing and Fold</h6>
                    </div>
                    <div className='card-content'>
                        We will wash, dry, and fold your clothes with care and precision, so you can enjoy fresh, clean laundry service without the hassle.
                    </div>
                    <div className='card-price'>
                        <h6>59 Rs/Kg</h6>
                    </div>
                    <div className='card-button'>
                        <Link to="/pricing" id='form-button-click' style={{ color: "white", textDecoration: "none" }}><Button onMouseEnter={event => {
                            document.querySelectorAll( ".card-image-normal" )[ 1 ].style.display = "none";
                            document.querySelectorAll( ".card-image-dark" )[ 1 ].style.display = "block";
                        }} onMouseLeave={event => {
                            document.querySelectorAll( ".card-image-dark" )[ 1 ].style.display = "none";
                            document.querySelectorAll( ".card-image-normal" )[ 1 ].style.display = "block";
                        }}>Book Now</Button></Link>
                    </div>
                </swiper-slide>
                <swiper-slide className='services-content-card'>
                    <div className='card-image'>
                        <img src={require( "../../images/services/wash-and-iron.png" )} className="card-image-normal" alt="" />
                        <img src={require( "../../images/services/wash-and-iron-dark.png" )} className="card-image-dark" alt="" />
                    </div>
                    <div className='card-head'>
                        <h6>Washing and Ironing</h6>
                    </div>
                    <div className='card-content'>
                        Our skilled cleaners will wash and iron your clothes to perfection, leaving them looking neat and tidy at your home doorstep.
                    </div>
                    <div className='card-price'>
                        <h6>79 Rs/Kg</h6>
                    </div>
                    <div className='card-button'>
                        <Link to="/pricing" id='form-button-click' style={{ color: "white", textDecoration: "none" }}><Button onMouseEnter={event => {
                            document.querySelectorAll( ".card-image-normal" )[ 2 ].style.display = "none";
                            document.querySelectorAll( ".card-image-dark" )[ 2 ].style.display = "block";
                        }} onMouseLeave={event => {
                            document.querySelectorAll( ".card-image-dark" )[ 2 ].style.display = "none";
                            document.querySelectorAll( ".card-image-normal" )[ 2 ].style.display = "block";
                        }}>Book Now</Button></Link>
                    </div>
                </swiper-slide>
                <swiper-slide className='services-content-card'>
                    <div className='card-image'>
                        <img src={require( "../../images/services/shoe-cleaning.png" )} className="card-image-normal" alt="" />
                        <img src={require( "../../images/services/shoe-cleaning-dark.png" )} className="card-image-dark" alt="" />
                    </div>
                    <div className='card-head'>
                        <h6>Shoe Cleaning</h6>
                    </div>
                    <div className='card-content'>
                        We use specialized cleaning techniques and products to restore your shoes to their original condition, no matter how dirty or worn they are.
                    </div>
                    <div className='card-price'>
                        <h6>299 Rs/Piece</h6>
                    </div>
                    <div className='card-button'>
                        <Link to="/pricing" id='form-button-click' style={{ color: "white", textDecoration: "none" }}><Button onMouseEnter={event => {
                            document.querySelectorAll( ".card-image-normal" )[ 3 ].style.display = "none";
                            document.querySelectorAll( ".card-image-dark" )[ 3 ].style.display = "block";
                        }} onMouseLeave={event => {
                            document.querySelectorAll( ".card-image-dark" )[ 3 ].style.display = "none";
                            document.querySelectorAll( ".card-image-normal" )[ 3 ].style.display = "block";
                        }}>Book Now</Button></Link>
                    </div>
                </swiper-slide>
                <swiper-slide className='services-content-card'>
                    <div className='card-image'>
                        <img src={require( "../../images/services/steam-press.png" )} className="card-image-normal" alt="" />
                        <img src={require( "../../images/services/steam-press-dark.png" )} className="card-image-dark" alt="" />
                    </div>
                    <div className='card-head'>
                        <h6>Steam Press</h6>
                    </div>
                    <div className='card-content'>
                        We use advanced steam pressing technology to remove wrinkles and creases from your clothes, leaving them looking smooth and polished.
                    </div>
                    <div className='card-price'>
                        <h6>10 Rs/Piece</h6>
                    </div>
                    <div className='card-button'>
                        <Link to="/pricing" id='form-button-click' style={{ color: "white", textDecoration: "none" }}><Button onMouseEnter={event => {
                            document.querySelectorAll( ".card-image-normal" )[ 4 ].style.display = "none";
                            document.querySelectorAll( ".card-image-dark" )[ 4 ].style.display = "block";
                        }} onMouseLeave={event => {
                            document.querySelectorAll( ".card-image-dark" )[ 4 ].style.display = "none";
                            document.querySelectorAll( ".card-image-normal" )[ 4 ].style.display = "block";
                        }}>Book Now</Button></Link>
                    </div>
                </swiper-slide>
                <swiper-slide className='services-content-card'>
                    <div className='card-image'>
                        <img src={require( "../../images/services/sofa-cleaning.png" )} className="card-image-normal" alt="" />
                        <img src={require( "../../images/services/sofa-cleaning-dark.png" )} className="card-image-dark" alt="" />
                    </div>
                    <div className='card-head'>
                        <h6>Sofa Cleaning</h6>
                    </div>
                    <div className='card-content'>
                        Our expert cleaners will remove dirt, dust, and allergens from your sofa, leaving it looking and smelling like new Sofa.
                    </div>
                    <div className='card-price'>
                        <h6>249 Rs/Seat</h6>
                    </div>
                    <div className='card-button'>
                        <Link to="/pricing" id='form-button-click' style={{ color: "white", textDecoration: "none" }}><Button onMouseEnter={event => {
                            document.querySelectorAll( ".card-image-normal" )[ 5 ].style.display = "none";
                            document.querySelectorAll( ".card-image-dark" )[ 5 ].style.display = "block";
                        }} onMouseLeave={event => {
                            document.querySelectorAll( ".card-image-dark" )[ 5 ].style.display = "none";
                            document.querySelectorAll( ".card-image-normal" )[ 5 ].style.display = "block";
                        }}>Book Now</Button></Link>
                    </div>
                </swiper-slide>
                <swiper-slide className='services-content-card'>
                    <div className='card-image'>
                        <img src={require( "../../images/services/house-cleaning.png" )} className="card-image-normal" alt="" />
                        <img src={require( "../../images/services/house-cleaning-dark.png" )} className="card-image-dark" alt="" />
                    </div>
                    <div className='card-head'>
                        <h6>House Cleaning</h6>
                    </div>
                    <div className='card-content'>
                        Our team of professionals will clean every nook and cranny of your home, from bathrooms and kitchens to bedrooms and living spaces.
                    </div>
                    <div className='card-price'>
                        <h6>5 Rs/Sqft</h6>
                    </div>
                    <div className='card-button'>
                        <Link to="/pricing" id='form-button-click' style={{ color: "white", textDecoration: "none" }}><Button onMouseEnter={event => {
                            document.querySelectorAll( ".card-image-normal" )[ 6 ].style.display = "none";
                            document.querySelectorAll( ".card-image-dark" )[ 6 ].style.display = "block";
                        }} onMouseLeave={event => {
                            document.querySelectorAll( ".card-image-dark" )[ 6 ].style.display = "none";
                            document.querySelectorAll( ".card-image-normal" )[ 6 ].style.display = "block";
                        }}>Book Now</Button></Link>
                    </div>
                </swiper-slide>
                <swiper-slide className='services-content-card'>
                    <div className='card-image'>
                        <img src={require( "../../images/services/saree-polish.png" )} className="card-image-normal" alt="" />
                        <img src={require( "../../images/services/saree-polish-dark.png" )} className="card-image-dark" alt="" />
                    </div>
                    <div className='card-head'>
                        <h6>Saree Polish</h6>
                    </div>
                    <div className='card-content'>
                        Our team of experts will clean, polish, and press your sarees, leaving them looking vibrant and beautiful while delivering to your home.
                    </div>
                    <div className='card-price'>
                        <h6>89 Rs/Piece</h6>
                    </div>
                    <div className='card-button'>
                        <Link to="/pricing" id='form-button-click' style={{ color: "white", textDecoration: "none" }}><Button onMouseEnter={event => {
                            document.querySelectorAll( ".card-image-normal" )[ 7 ].style.display = "none";
                            document.querySelectorAll( ".card-image-dark" )[ 7 ].style.display = "block";
                        }} onMouseLeave={event => {
                            document.querySelectorAll( ".card-image-dark" )[ 7 ].style.display = "none";
                            document.querySelectorAll( ".card-image-normal" )[ 7 ].style.display = "block";
                        }}>Book Now</Button></Link>
                    </div>
                </swiper-slide>
            </swiper-container>
        </div>
    )
}

export default Services